import posthog from "posthog-js";
export const POSTHOG_SUPER_PROPERTIES = {
	$sg_version: "v2",
	$sg_app: "PWA",
};

export function usePostHog() {
	// Resets posthog but keeps super properties
	function safeReset() {
		posthog.reset();
		posthog.register(POSTHOG_SUPER_PROPERTIES);
	}

	return {
		safeReset,
		posthog,
	};
}
